// Libs
import React from 'react'
import { applyRouterMiddleware, Router, Route, browserHistory } from 'react-router'
import { useScroll } from 'react-router-scroll';

//components
import App from './App';
import Home from './components/home/Home'
import FAQs from './components/pages/FAQs'
import About from './components/pages/About'
import Research from './components/pages/Research'
import WhatIf from './components/pages/WhatIf'

const Routes = (props) => {
  return (
    <Router history={browserHistory} render={applyRouterMiddleware(useScroll())} >
      <Route component={App} >
        <Route path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/faqs" component={FAQs} />
        <Route path="/research" component={Research} />
        <Route path="/whatif" component={WhatIf} />
      </Route>
    </Router>
  );
}

export default Routes



/** WEBPACK FOOTER **
 ** ./src/router.js
 **/